import './assets/confirmation.css';
import './assets/checkout.css';
import { createApp } from '@domgen/whirlpool-olr';
import { ClientLogo } from './assets/icons/ClientLogo';

createApp({
  clientLogo: <ClientLogo />,
});
